import React from 'react';
import { connect } from 'react-redux';
import { round } from 'lodash';

function MeasurementCard({ gradingData, showGrading, isGradingChange, isMeasurementChange, isOldData, isApproved }) {
  const showGradingValue = (grading) => {
    if (!Number.isNaN(grading) && !Number.isNaN(parseFloat(grading))) {
      return round(parseFloat(grading), 3);
    }
    return grading;
  };
  return (
    <table className="fraction-table">
      <tr className={isOldData && isApproved && isMeasurementChange && 'suggested-data'}>
        <td>{showGradingValue(gradingData.measurment)}</td>
      </tr>

      {showGrading && (
        <tr className={isGradingChange && 'suggested-data'}>
          <td>
            <p className="mb-0">{showGradingValue(gradingData.grading)}</p>
          </td>
        </tr>
      )}
    </table>
  );
}

const mapStateToProps = ({ UserDetails }) => {
  const { userInfo } = UserDetails;
  return {
    userInfo,
  };
};

const mapStateToDispatch = {};

export default connect(mapStateToProps, mapStateToDispatch)(MeasurementCard);
